module.exports = "/images/au.svg?cc44a5a1e9bf598fa71861e0a416e085";